import {
  bestPocPodSoftwareUk,
  gpsProofOfDelivery,
  pocPodSoftware,
  proofOfCollectionSoftware,
  whatIsPocPod,
} from "./pocPod";
import {
  vehicleConditionReportSoftware,
  vehicleDamageInspectionSoftware,
  vehicleInspectionSoftware,
} from "./inspection";
import {
  carTransporterSoftware,
  vehicleDeliverySoftware,
  vehicleDeliveryTracking,
  vehicleTransportDriverApp,
} from "./operations";
import { aiVehicleDamageDetection } from "./aiDamage";
import { transportInvoicingSoftware } from "./invoicing";
import { vehicleTransportSoftwareForSmallBusinesses } from "./smallBusiness";
import { tradePlateDriverSoftware } from "./tradePlate";
import type { SeoPageContent } from "./types";

/** All standalone SEO content pages, rendered by SeoContentPage and listed in the sitemap. */
export const SEO_PAGES: SeoPageContent[] = [
  bestPocPodSoftwareUk,
  pocPodSoftware,
  proofOfCollectionSoftware,
  whatIsPocPod,
  gpsProofOfDelivery,
  vehicleInspectionSoftware,
  vehicleDamageInspectionSoftware,
  vehicleConditionReportSoftware,
  vehicleDeliverySoftware,
  carTransporterSoftware,
  vehicleTransportDriverApp,
  vehicleDeliveryTracking,
  aiVehicleDamageDetection,
  transportInvoicingSoftware,
  vehicleTransportSoftwareForSmallBusinesses,
  tradePlateDriverSoftware,
];

export type { SeoPageContent };
